<template>
    <div class="bg-white p-5" style="border: solid 1px grey;">
        <div>
            <h4>Bài tập về nhà buổi {{ lesson_alias || lesson }}</h4>
        </div>
        <hr/>
        <div v-loading="loadingMarkHomework" class="modal-fillter-poin table">
            <div class="table-responsive overflow-auto mt-3">
                <table :aria-busy="isBusy" class="table" style="text-align: center;">
                    <thead>
                        <tr>
                            <th scope="col" class="min-w-100px">Họ và tên</th>
                            <th scope="col" class="min-w-100px">Mã học viên</th>
                            <th scope="col" class="min-w-100px">Số điện thoại</th>
                            <th scope="col" class="min-w-100px">Trạng thái</th>
                            <th scope="col" class="min-w-120px">Hình thức chấm</th>
                            <th scope="col" class="text-center">Thời gian GV chấm bài</th>
                            <th scope="col" class="min-w-120px">Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                        <HomeWork v-for="(item, index) in homeWorkList" :learning_schedule_id="learning_schedule_id"
                            :lessonNumber="lesson" @action-mark-homework="actionMarkHomework" :homeWork="item"
                            :key="index" @resetHomework="openResetHomeworkDialog"></HomeWork>
                    </tbody>
                </table>
            </div>
        </div>
        <ResetHomeworkMarkDialog
            :visible.sync="resetDialog"
            :student-name="resetHomeworkData.name"
            :loading="resetLoading"
            @confirm="submitResetHomework"
        />
    </div>
</template>

<script>
import HomeWork from './components/HomeWork.vue';
import ResetHomeworkMarkDialog from './components/ResetHomeworkMarkDialog.vue';
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {ADMIN_HOMEWORK, RESET_HOMEWORK_MARK} from "@/core/services/store/course/classes.module";

export default {
    components: {
        HomeWork,
        ResetHomeworkMarkDialog,
    },
    data() {
        return {
            lesson: null,
            lesson_alias: null,
            classroom_id: null,
            learning_schedule_id: null,
            homeWorkList:[],
            loadingMarkHomework: false,
            resetDialog: false,
            resetLoading: false,
            resetHomeworkData: {},
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Chi tiết lớp học", route: 'schedule-class' },
            { title: "Danh sách lớp học" }
        ]);
        this.lesson = this.$route.query.lesson
        this.lesson_alias = this.$route.query.lesson_alias
        this.classroom_id = this.$route.query.classroom_id
        this.learning_schedule_id = this.$route.query.learning_schedule_id
        this.getListHomework()
    },
    methods: {
        getListHomework() {
            this.loadingMarkHomework = true;
            return this.$store.dispatch(ADMIN_HOMEWORK, {classroom_id:this.classroom_id,lesson:this.lesson,type:'homework'}).then((res) => {
                if (!res.error) {
                    this.homeWorkList = res.data;
                }
            }).catch((e) => {
                console.log(e, 'error')
            }).finally(() => {
                this.loadingMarkHomework = false;
            });
        },
        openResetHomeworkDialog(homeWork) {
            this.resetHomeworkData = homeWork;
            this.resetDialog = true;
        },
        submitResetHomework() {
            if (!this.resetHomeworkData.test) {
                return;
            }

            this.resetLoading = true;
            this.$store.dispatch(RESET_HOMEWORK_MARK, {
                overall_result_id: this.resetHomeworkData.test.overall_id
            }).then((res) => {
                if (res.error) {
                    this.$message({
                        type: 'error',
                        message: res.message || 'Reset kết quả chấm thất bại!',
                        showClose: true
                    });
                    return;
                }

                this.$message({
                    type: 'success',
                    message: 'Reset kết quả chấm thành công!',
                    showClose: true
                });
                return this.getListHomework().then(() => {
                    this.resetDialog = false;
                    this.resetHomeworkData = {};
                });
            }).catch((e) => {
                const message = e?.data?.message || 'Reset kết quả chấm thất bại!';
                this.$message({
                    type: 'error',
                    message,
                    showClose: true
                });
            }).finally(() => {
                this.resetLoading = false;
            });
        }
    },
}
</script>

<style lang="scss" scoped></style>
